module.exports = __webpack_public_path__ + "static/assets/99c18ed3fcf835ba2176971762abd9f7.svg";